import { render, staticRenderFns } from "./dashboard-table.component.vue?vue&type=template&id=d683f4f6"
import script from "./dashboard-table.component.vue?vue&type=script&lang=js"
export * from "./dashboard-table.component.vue?vue&type=script&lang=js"
import style0 from "./dashboard-table.component.vue?vue&type=style&index=0&id=d683f4f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports